import { ReactNode } from "react";
import { useTunnels } from "../context/tunnels";

/**
 * Host-app items for the toolbar's "more tools" flyout, rendered under its
 * Generate group. Same tunnel pattern as `TTDDialogTrigger`: the host renders
 * this anywhere inside `<Excalidraw>`, the flyout shows its children.
 */
export const ExtraToolsSlot = ({ children }: { children: ReactNode }) => {
  const { ExtraToolsTunnel } = useTunnels();
  return <ExtraToolsTunnel.In>{children}</ExtraToolsTunnel.In>;
};
ExtraToolsSlot.displayName = "ExtraToolsSlot";
